export default __webpack_public_path__ + "static/media/simonSound4.60f3cc7d.mp3";